<template>
    <div>
        <card title="Historial" icon="list-alt">
            <div class="row">
                <div class="col-md-12 text-right">
                    <button class="btn btn-primary" @click="backLink"><i class="fa fa-arrow-left"></i></button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <card class="card cardShadow-light" title="Datos Principales">
                        <div class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th>Centro de Costo</th>
                                    <td>{{ mainData.costCenter }}</td>
                                </tr>
                                <tr>
                                    <th>N° Guía</th>
                                    <td>{{ mainData.guideNumber }}</td>
                                </tr>
                                <tr>
                                    <th>Agente</th>
                                    <td>
                                        <a v-if="mainData.url" target="_blank" @click.prevent="copyAndRedirect(mainData.guideNumber, mainData.url)" class="btn btn-warning"><i class="fas fa-plane-departure"></i> Seguimiento {{ mainData.agentName }}</a>
                                        <span v-else>{{ mainData.agentName }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Estado</th>
                                    <td>{{ mainData.status }}</td>
                                </tr>
                                <tr>
                                    <th>Fecha de creación</th>
                                    <td>{{ mainData.createDateString }}</td>
                                </tr>
                                <tr>
                                    <th>Fecha de actualización</th>
                                    <td>{{ mainData.updatedDateString }}</td>
                                </tr>
                                <tr>
                                    <th>Fecha de Envío:</th>
                                    <td>{{ mainData.sendedAtString }}</td>
                                </tr>
                                <tr>
                                    <th>Fecha/Hora Límite de Gestión:</th>
                                    <td>
                                        <span v-if="mainData.dispatchManagementDeadlineString">{{ mainData.dispatchManagementDeadlineString }}</span>
                                        <span v-else class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </card>
                </div>
                <div class="col-md-8">
                    <card title="Seguimiento">
                        <div class="timeline">
                            <div v-for="(detail) in details" :key="detail.id" class="timeline-item">
                                <div class="timeline-marker"></div>
                                <div class="timeline-content">
                                    <div class="timeline-header">
                                        <div class="row">
                                            <div class="col-md-10">
                                                <span class="timeline-date timeline-blue-muted-text"><b>Fecha: {{ detail.statusDate }}</b></span><br/>
                                                <span class="timeline-status" style="font-size: 22px;"><b>Estado: {{ detail.status }}</b></span>
                                            </div>
                                            <div class="col-md-2 text-right">
                                                <span class="badge timeline-pill-badge" style="font-size: 18px; border: 4px solid white; "><b>{{ detail.trackingCode }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                    <p>{{ detail.statusDetail }}</p>
                                    <!--<span class="badge badge-primary">{{ detail.trackingCode }}</span>-->
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
            
        </card>
    </div>
</template>

<script>
import { Get } from '../../helper/axios';

export default {
    name: "HotExpressTrackingDetail",
    data() {
        return {
            details: [],
            mainData: {},
            Get,
            apiUrl: this.$store.getters.apiUrl,
            id: this.$route.params.id
        }
    },
    created() {
        this.index();
    },
    methods: {
        index() {
            this.Get(this.apiUrl + "v1/hotexpressguidenumbers/" + this.id, (res) => {
                this.details = res.data.data.hotExpressTrackings;
                this.mainData = res.data.data.hotExpressGuideNumber;
                this.$store.commit("setLoading", false);
            });
        },
        copyAndRedirect (text, url) {
            try {
                navigator.clipboard.writeText(text);
            } catch (err) {
                console.error('Error al copiar: ', err);
            }

            window.open(url, '_blank');
        },
        backLink() {
            history.back();
        }
    }
}
</script>